import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from '@tanstack/react-query';
import Axios from './../../apiConfig/Axios';
import apiRoutes from 'services/apiRoutes';

//////////////////////////////////////changePassword//////////////////////////

const fetchChangePasswordFn = async (data: reqChangePasswordType) => {
  const res = await Axios.post<GlobalApiResponseType<string>>(
    apiRoutes.changePassword.Post,
    data
  );
  return res.data;
};

export const useChangePassword = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<string>,
      Error,
      reqChangePasswordType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<string>,
    Error,
    reqChangePasswordType
  >(['changePassword'], fetchChangePasswordFn, option);
};

//////////////////////////////////////validation//////////////////////////

const fetchChangePasswordValidationFn = async (
  data: reqChangePasswordValidationType
) => {
  const res = await Axios.post<GlobalApiResponseType<string>>(
    apiRoutes.changePassword.ValidationWithCaptcha,
    data
  );
  return res.data;
};

export const useChangePasswordValidation = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<string>,
      Error,
      reqChangePasswordValidationType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<string>,
    Error,
    reqChangePasswordValidationType
  >(['changePasswordOtp'], fetchChangePasswordValidationFn, option);
};

//////////////////////////////////////ChangePassword Request//////////////////////////

// const fetchChangePasswordRequestFn = async () => {
//   const res = await Axios.post<GlobalApiResponseType<resChangePasswordRequestType>>(
//     apiRoutes.forceChangePassword.Request
//   );
//   return res.data;
// };

// export const useChangePasswordRequest = (
//   option?: Omit<
//     UseMutationOptions<
//       GlobalApiResponseType<resChangePasswordRequestType>,
//       Error
//     >,
//     'mutationKey' | 'mutationFn'
//   >
// ) => {
//   return useMutation<
//     GlobalApiResponseType<resChangePasswordRequestType>,
//     Error
//   >(fetchChangePasswordRequestFn, option);
// };

const fetchChangePasswordRequestFn = async () => {
  const res = await Axios.get<
    GlobalApiResponseType<resChangePasswordRequestType>
  >(apiRoutes.changePassword.RequestGEt);
  return res.data;
};

export const useGetChangePassword = (forse: boolean) => {
  return useQuery<GlobalApiResponseType<resChangePasswordRequestType>, Error>(
    ['changePassword-request'],
    fetchChangePasswordRequestFn,
    {
      enabled: !forse,
    }
  );
};
